import { usePostHog } from "posthog-js/react";
import { eventNames, trackEvent } from "@/utils/analytics";
import type { EventName } from "@/utils/analytics";

export const useAnalytics = () => {
  const posthog = usePostHog();

  return {
    posthog,
    trackEvent: (name: EventName, properties?: Record<string, unknown>) =>
      trackEvent(posthog, name, properties),
    eventNames,
  };
};
